import { Notice } from "../../models/notice";
import { useTranslation } from "react-i18next";

export function CheckInDetailNoticeCell({ notice }: { notice: Notice }) {
  const { t } = useTranslation();

  return (
    <div className={"w-full rounded-md border border-base-300 p-3"}>
      <div className={"text-sm font-bold flex gap-2 mb-1"}>
        {notice.isPrimary && (
          <span className={"badge badge-error flex-shrink-0"}>
            {t("notice_important_badge")}
          </span>
        )}
        <p className={"line-clamp-1 break-all"}>
          {notice.title || notice.content}
        </p>
      </div>
      <p className={"text-sm break-all whitespace-pre-line line-clamp-3"}>
        {notice.content}
      </p>
    </div>
  );
}
